import {
  DecisionTableField,
  ScorecardCase,
  ScorecardFactor,
} from "src/clients/flow-api";
import { ScorecardNodeData } from "src/constants/NodeDataTypes";
import { predicateToSearchableField } from "src/flowGraph/canvasSearch/nodesExtractors/decisionTableExtractors";

const extractWithPrefix = (field: DecisionTableField) => {
  return {
    id: field.id,
    value: `data.${field.value}`,
  };
};

const extractCase = (caseItem: ScorecardCase) => {
  return [predicateToSearchableField(caseItem.predicate), caseItem.effect];
};

const extractFactor = ({
  factor,
  extractScores,
  equalWeights,
}: {
  factor: ScorecardFactor;
  extractScores: boolean;
  equalWeights: boolean;
}) => {
  return [
    factor.input_field,
    ...(equalWeights ? [] : [factor.weight]),
    ...factor.cases.flatMap(extractCase),
    factor.fallback,
    ...(extractScores ? [extractWithPrefix(factor.output_field)] : []),
  ];
};

export const extractScorecardFields = (data: ScorecardNodeData) => {
  const fields = [];

  if (data.assign_field.value) {
    fields.push(extractWithPrefix(data.assign_field));
  }

  fields.push(
    ...data.factors.flatMap((factor) =>
      extractFactor({
        factor,
        extractScores: data.extract_scores,
        equalWeights: data.equal_weights,
      }),
    ),
  );

  return fields;
};
